import { createPiniaOrmAxios } from '@pinia-orm/axios';
import { createPinia, setActivePinia } from 'pinia';
import { createORM } from 'pinia-orm';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { jsonApiClient } from '@/httpConfig/config/axios.js';

export function setupPinia(app) {


  const pinia = createPinia();//.use(createORM().use(piniaOrmAxios))
  const piniaOrm = createORM({
    plugins: [
      createPiniaOrmAxios({
        axios: jsonApiClient, // ✅ Works because it's a real axios instance
        dataTransformer: (response) => {
          // Response is already transformed by jsonApiClient
          return response.data.data;
        },
      }),
    ],
  });
  pinia.use(piniaOrm);
  pinia.use(piniaPluginPersistedstate);
  app.use(pinia);
  setActivePinia(pinia);


  return { pinia, piniaOrm };
}
